import { render } from "./News_m.vue?vue&type=template&id=208fa810"
import script from "./News_m.vue?vue&type=script&lang=js"
export * from "./News_m.vue?vue&type=script&lang=js"
script.render = render

export default script